// src/config.js
const config = {
  // baseURL: "http://localhost:5000",
  baseURL: "https://backoffice2.scmt.pt",
  frontURL: "https://frontoffice.scmt.pt",
  // frontURL: "http://localhost:3000",
};

export default config;
